<script setup lang="ts">
interface IProps {
  expand?: boolean
  append?: boolean
}

const props = defineProps<IProps>()
const isShow = ref(false)

onBeforeMount(() => {
  if (props.expand) isShow.value = true
})

const toggle = () => {
  isShow.value = !isShow.value
}

const icon = computed(() => {
  return isShow.value ? 'chevron-down' : 'chevron-right'
})
</script>

<template>
  <div class="expand-container">
    <div
      class="flex gap-x-4 cursor-pointer items-center p-4"
      :class="{ 'flex-row-reverse': append}"
      @click="toggle"
    >
      <div class="icon">
        <FontAwesomeIcon
          :icon="icon"
          class="text-xl"
        />
      </div>

      <div class="flex-1">
        <slot name="title" />
      </div>
    </div>

    <div
      class="expand-body"
      v-if="isShow"
    >
      <slot name="body" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.expand-container {

  .icon {
    @apply p-2 text-primary text-base flex justify-center items-center;

    @include sm {
      @apply mr-2;
    }
  }
}
</style>
